import { env } from "@/config/env";

const MAX_LENGTH_PHONE = 14;
const MAX_LENGTH_CNPJ = 18;
const IS_DEV = env.ENVIRONMENT === "development";

export const constants = {
  MAX_LENGTH_PHONE,
  MAX_LENGTH_CNPJ,
  IS_DEV,
};
